import BaseTableCard from 'common/components/BaseTableCard'
import BasicTable from 'common/components/BasicTable'
import { Column } from 'common/components/BasicTable/types'
import { fNumber } from 'common/utils/formatNumber'
import { useMedicinesSummaryToday } from 'modules/medicalSupply/api/selector'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Typography } from '@mui/material'

import MedicalSupplyDialog from '../MedicalSupplyDialog'
import './style.css'

const MedicalSupplyOverview = () => {
  const { t } = useTranslation('medicalsupply')

  const { data, isFetching, refetch } = useMedicinesSummaryToday()

  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const columns: Column[] = [
    {
      id: 'medicine',
      title: t('medicine'),
    },
    {
      id: 'today',
      title: t('use.today'),
      align: 'left',
    },
  ]

  const createTableRows = (id: string, medicine: string, today: string) => {
    return {
      medicine: <Typography>{medicine}</Typography>,
      today: <Typography fontWeight={600}>{today}</Typography>,
    }
  }

  const rows = (data ?? [])?.map((el) =>
    createTableRows('', el.medicine_name, `${fNumber(el.totalAmount)} ${el.unit}`)
  )

  return (
    <>
      <BaseTableCard
        title={t('overview')}
        refresh={refetch}
        isLoading={isFetching}
        isEmpty={false}
        disableShowDateFilter={true}
        disableRefresh={true}
      >
        <Box className="medicine-table">
          <BasicTable columns={columns} onLoading={() => {}} isLoading={isFetching} rows={rows} />
        </Box>
      </BaseTableCard>
      <MedicalSupplyDialog onClose={handleClose} open={open} isEdit />
    </>
  )
}

export default MedicalSupplyOverview
